import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/henripay_dashboard/domains/dashboard.henripay.com/node_modules/@mui/material/Button/Button.js");
;
import(/* webpackMode: "eager" */ "/home/henripay_dashboard/domains/dashboard.henripay.com/node_modules/next/dist/client/image-component.js");
